/**
 * 콘텐츠 URL 이 캠페인의 채널/콘텐츠 유형에 맞지 않을 때 던지는 sentinel 에러.
 *
 * 콘텐츠 등록 제출 검증은 두 단계인데, 둘 다 "채널/유형 불일치" 라는 점에서 동일하므로
 * 토스트가 아니라 콘텐츠 URL 인풋의 인라인 에러(빨간 border + 빨간 help text)로 **일원화**한다.
 * - 클라 사전검증: 입력 URL host 로 채널 판별 + 캠페인 허용채널 교차검증 (not_allowed/undetectable)
 * - 서버 응답: 400 + code `COMMON-001-002` (해당 채널에서 만들 수 없는 콘텐츠 유형)
 *
 * 호출 측(page)이 위 케이스를 감지해 이 에러를 throw 하면, `ContentSubmissionPageView` 가
 * `instanceof` 로 받아 인라인 에러를 노출한다(고정 문구). 그 외 실패는 page 가 토스트로 처리.
 */
export class ContentUrlValidationError extends Error {
  constructor() {
    super('content url channel/type mismatch');
    this.name = 'ContentUrlValidationError';
  }
}

/**
 * `ContentUrlValidationError` 판정. app(throw) ↔ features(catch) 패키지 경계에서 번들 중복으로
 * `instanceof` 가 깨질 수 있어 `name` 기반 fallback 을 함께 둔다.
 */
export const isContentUrlValidationError = (error: unknown): boolean =>
  error instanceof ContentUrlValidationError ||
  (error instanceof Error && error.name === 'ContentUrlValidationError');
